import { Dropdown, Image, Menu } from 'antd';
import UserMenu from './components/UserMenu';
import trackex from '@/pages/login/images/trackex.png';
import { Link, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChartLine,
  faClockRotateLeft,
  faEllipsisVertical,
  faListCheck
} from '@fortawesome/free-solid-svg-icons';
import { getLoggedInUser } from 'utilities/helpers';
import { EXECUTIVE, MANAGER } from 'utilities/roleRights';
import NotificationPanel from './components/NotificationPanel';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ApartmentOutlined } from '@ant-design/icons';

const CustomLayout = ({ children, header = true }) => {
  // const user = JSON.parse(localStorage.getItem('Gravity_user'));
  const { user_details } = getLoggedInUser();
  const dispatch = useDispatch();

  const activePathClassnames = ({ isActive }) => {
    return `${
      isActive
        ? '!text-[#2563EB] hover:!text-[#2563EB]'
        : 'hover:text-[#2563EB] !text-[#64748B]'
    } flex items-center gap-2 font-medium text-xs sm:text-sm`;
  };

  const menu = (
    <Menu>
      <Menu.Item key="dashboard">
        <NavLink to="/dashboard" className={activePathClassnames}>
          <FontAwesomeIcon icon={faChartLine} />
          Home
        </NavLink>
      </Menu.Item>
      <Menu.Item key="tasks">
        <NavLink to="/my-tasks" className={activePathClassnames}>
          <FontAwesomeIcon icon={faListCheck} />
          Tasks
        </NavLink>
      </Menu.Item>
      {user_details?.role_id === MANAGER && (
        <Menu.Item key="follow-up">
          <NavLink to="/follow-up" className={activePathClassnames}>
            <FontAwesomeIcon icon={faClockRotateLeft} />
            Follow-ups
          </NavLink>
        </Menu.Item>
      )}
    </Menu>
  );

  useEffect(() => {
    dispatch({ type: 'socket/connect' });
  }, []);

  return (
    <div>
      {header ? (
        <div
          className={`h-[51px] w-full fixed xl:px-20 md:px-10 px-3 sm:px-4 z-10 bg-[#fff] !top-0 border-b border-[#e6dede] flex justify-between items-center`}
          style={{ border: '1px solid #e6dede' }}
        >
          <div className="flex items-center gap-4 md:gap-12 sfprotext-medium">
            <div className="flex items-center md:hidden">
              <Dropdown
                overlay={menu}
                trigger={['click']}
                overlayClassName="!pt-4"
              >
                <FontAwesomeIcon icon={faEllipsisVertical} />
              </Dropdown>
            </div>

            <Link to="/dashboard">
              <Image
                className={`h-5 md:h-6 w-auto`}
                // alt="Trackex logo"
                src={trackex}
                preview={false}
              />
            </Link>

            <div className="hidden md:flex items-center gap-6 text-sm !sfprotext-medium">
              <NavLink to="/dashboard" className={activePathClassnames}>
                <FontAwesomeIcon icon={faChartLine} />
                Home
              </NavLink>
              <NavLink to="/my-tasks" className={activePathClassnames}>
                <FontAwesomeIcon icon={faListCheck} />
                Tasks
              </NavLink>
              {[MANAGER, EXECUTIVE].includes(user_details?.role_id) ? (
                <NavLink to="/follow-up" className={activePathClassnames}>
                  <FontAwesomeIcon icon={faClockRotateLeft} />
                  Follow-ups
                </NavLink>
              ) : null}
              {[MANAGER, EXECUTIVE].includes(user_details?.role_id) ? (
                <NavLink to="/plan-staffing" className={activePathClassnames}>
                  {/* <FontAwesomeIcon icon={ApartmentOutlined} /> */}
                  <ApartmentOutlined />
                  Staffing
                </NavLink>
              ) : null}
            </div>
          </div>

          <div className="flex items-center gap-4">
            <NotificationPanel />
            <UserMenu />
          </div>
        </div>
      ) : null}

      <div className={'xl:m-20 my-16 md:my-20 mx-2 sm:mx-4 md:mx-10'}>
        {children}
      </div>
    </div>
  );
};

export default CustomLayout;
